import spiderman from '@/spiderman/index';

async function send(member, feedbackForm) {
  return (
    await spiderman.axios.post(spiderman.api.feedbacks,
      feedbackForm,
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  send,
};
